import { Inject, Injectable } from '@angular/core';
import { Data } from '@angular/router';

@Injectable({
    providedIn: 'root',
})

export class UtilityService {
    constructor(
        @Inject('MergeArrayByKey') private readonly mergeArrayByKey,
    ) {}

    public mergeArray(key: string, arrayA: Data[], arrayB: Data[]): Data[] {
        return this.mergeArrayByKey(key, arrayA, arrayB);
    }
}
